import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';

declare var $;
declare var ldBar;

@Component({
  selector: 'progress-circle',
  templateUrl: 'progress-circle.html',
  inputs: ['title', 'is', 'should', 'separator', 'unit'],
})
export class ProgressCircle {


  label: string = "";
  value: string = "";
  progressCounter: any = 0;
  animation: any;
  title: string;
  is: any;
  should: any;
  separator: string;
  unit: string;

  constructor(public platform: Platform) {
    setTimeout(() => {
      this.animateProgress();
    }, 500);
  }


  animateProgress() {
    var progress = document.querySelector("#progress-" + this.title);
    if (progress) {
      var progressElement = new ldBar(progress);
      progressElement.set(0);
      $(".progress").css('opacity', '1.0');
      var percentage = (Number(this.is) / Number(this.should)) * 100;
      progressElement.set(percentage);

      this.animation = setInterval(() => {
        if (Number(this.progressCounter) < Number(percentage)) {
          this.progressCounter = this.progressCounter + 1;
          progressElement.set(this.progressCounter);
        } else {
          clearInterval(this.animation);
        }
      }, 20);
    }
  }



}



// WEBPACK FOOTER //
// ./src/components/progress-circle/progress-circle.ts